import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import CrmUpgrade from "./CrmUpgrade";
import "./Crm.css";

/**
 * Shared chrome for the CRM pages: sidebar, header, loading/upgrade states.
 *
 * The four original pages (Overview, Leads, Clients, Follow-ups) predate this
 * and carry their own shells because each has bespoke toolbars; everything
 * added since renders through here.
 */
function CrmPage({ title, subtitle, actions, loading, planBlocked, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
  return (
    <div className="crm-container">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="crm-main">
        <header className="crm-header">
          <div className="crm-header-left">
            <button className="crm-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
            <div>
              <h2>{title}</h2>
              {subtitle && <p className="crm-header-sub">{subtitle}</p>}
            </div>
          </div>
          {!planBlocked && actions}
        </header>

        <div className="crm-content">
          {planBlocked ? (
            <CrmUpgrade />
          ) : loading ? (
            <div className="crm-loading">Loading…</div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
}

export default CrmPage;
